/**
 * The metering statement (mission 9 WP11 T069; OR-13, U5; B.3, GL.4; contracts/ui-api.md
 * "Components"): what a credit meters, one component and one register key (`meteringStatement`),
 * mounted on sheets 06 (Signup), 08 (Subscribe), 11 (the estimate panel) and 50 (Billing). A screen
 * places it with `className`; the wording lives only in the register, for the copy owner (S18).
 */
import { cn } from '@/components/ui/cn'
import { copyText } from '@/lib/provisional-copy'

export interface MeteringStatementProps {
  className?: string
}

export function MeteringStatement({ className }: MeteringStatementProps) {
  return (
    <p data-testid="metering-statement" className={cn('text-body-sm text-navy-700', className)}>
      {copyText('meteringStatement')}
    </p>
  )
}
